<div class="grid-container padding-y-4">
  <form [formGroup]="freightQueryForm">
    <fieldset class="usa-fieldset">
      <legend class="usa-legend usa-legend--large">FRT Queries</legend>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="pickupdate" class="usa-label">Pick-Up Date<abbr title="required"
          class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="pickupdate" [minDate]="minDate" formControlName="pickupDate" class="usa-input" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" placeholder="MM/dd/yyyy" bsDatepicker>
          @if (this.freightQueryForm.get('pickupDate').touched && this.freightQueryForm.get('pickupDate').hasError('required')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Pick-Up Date is required
            </div>
          }
        </div>
        <div class="grid-col-4">
          <label for="type" class="usa-label">SRO Type<abbr title="required"
          class="usa-hint usa-hint--required">*</abbr></label>
          <select id="type" formControlName="sroType" class="usa-select" (change)="onSroTypeChange(this.freightQueryForm.get('sroType').value.name, this.freightQueryForm.get('sroType').value.sroType)">
            <option [ngValue]="null" selected disabled>Choose...</option>
            @for (type of types; track type) {
              <option [ngValue]="type">{{type.sroType}}</option>
            }
          </select>
          @if (this.freightQueryForm.get('sroType').touched && this.freightQueryForm.get('sroType').hasError('required')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> SRO Type is required
            </div>
          }
        </div>
        <div class="grid-col-4">
          <label for="sro_id" class="usa-label">SRO ID<abbr title="required"
          class="usa-hint usa-hint--required">*</abbr></label>
          <select id="sro_id" formControlName="sroId" class="usa-select">
            <option [ngValue]="null" selected disabled>Choose...</option>
            @for (sro of sroIds; track sro) {
              <option [ngValue]="sro.sroMasterId">{{sro.sroId}} - {{sro.sroNotes}}</option>
            }
          </select>
          @if (this.freightQueryForm.get('sroId').touched && this.freightQueryForm.get('sroId').hasError('required')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> SRO ID is required
            </div>
          }
        </div>
      </div>
      @if (showInternational) {
        <div class="grid-row grid-gap">
          <div class="grid-col-4">
            <label for="origin_country_select" title="origin country"  class="usa-label">Origin<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <select id="origin_country_select" aria-label="origincountry" class="usa-select" formControlName="originCountryId" [compareWith]="compareCountryFn">
              <option [ngValue]="null">..Select a Origin Country..</option>
              @for (origCountry of allCountriesList$ | async; track origCountry) {
                <option [ngValue]="origCountry">{{
                  origCountry.stateCountryName }}
                </option>
              }
            </select>
            @if (isFormElementInValid('originCountryId')) {
              <div class="text-danger">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Origin Country is required
              </div>
            }
          </div>
          <div class="grid-col-4">
            <label for="destination_country" class="usa-label">Destination<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <select id="destination_country" aria-labelledby="select destination country" class="usa-select" formControlName="destinationCountryId" [compareWith]="compareCountryFn">
              <option [ngValue]="null">..Select a Destination Country..</option>
              @for (country of allCountriesList$ | async; track country) {
                <option [ngValue]="country">{{ country.stateCountryName }}
                </option>
              }
            </select>
            @if (isFormElementInValid('destinationCountryId')) {
              <div class="text-danger">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Destination Country is required
              </div>
            }
          </div>
        </div>
      }
      @if (showCountries) {
        <div class="grid-row grid-gap">
          <div class="grid-col-4">
            <label for="origin_country_general" class="usa-label">Origin<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <select id="origin_country_general" class="usa-select" formControlName="originCountryId" [compareWith]="compareCountryFn">
              <option [ngValue]="null">..Select a Origin Country..</option>
              @for (origCountry of allCountriesFrtList$ | async; track origCountry) {
                <option [ngValue]="origCountry">{{
                  origCountry.stateCountryName }}
                </option>
              }
            </select>
            @if (isFormElementInValid('originCountryId')) {
              <div class="text-danger">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Origin Country is required
              </div>
            }
          </div>
          <div class="grid-col-4">
            <label for="destination_country_general" class="usa-label">Destination<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <select id="destination_country_general" class="usa-select" formControlName="destinationCountryId" [compareWith]="compareCountryFn">
              <option [ngValue]="null">..Select a Destination Country..</option>
              @for (country of allCountriesFrtList$ | async; track country) {
                <option [ngValue]="country">{{ country.stateCountryName }}
                </option>
              }
            </select>
            @if (isFormElementInValid('destinationCountryId')) {
              <div class="text-danger">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Destination Country is required
              </div>
            }
          </div>
        </div>
      }
      <ng-template #customItemTemplate let-model="item">{{model.cityName}} , {{model.stateAbbrev}} {{model.zipCode}} {{model.zipClassificationCode === 'P' ? 'P.O BOX ONLY' : ''}}</ng-template>
      @if (showOriginDestination) {
        <div class="grid-row grid-gap">
          @if ((showOriginDestinationInput || showOrigin) && !showOriginCanadianProvince) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="origin" class="usa-label">Origin<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <input id="origin" role="combobox" class="usa-input" formControlName="asyncOriginSearchString" [typeaheadAsync]="true" [typeahead]="dataSourceOrigin" (typeaheadLoading)="changeTypeaheadOriginLoading($event)" (typeaheadOnSelect)="typeaheadOriginOnSelect($event)" typeaheadOptionField="cityName"
                [typeaheadItemTemplate]="customItemTemplate" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" placeholder="Enter a location or zip code">
              @if (typeaheadLoading) {
                <div class="margin-y-2 spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              }
              @if (this.freightQueryForm.get('originId').touched && this.freightQueryForm.get('originId').hasError('required')) {
                <div class="text-danger">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Origin is required
                </div>
              }
              @if (freightQueryForm.value.originId) {
                <label class="usa-label define-bottom-tag">{{freightQueryForm.value.originId?.cityName}} , {{freightQueryForm.value.originId?.stateAbbrev}} {{freightQueryForm.value.originId?.zipCode}}</label>
              }
            </div>
          }
          @if (showOriginCanadianProvince) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="origin_country" class="usa-label">Origin Province<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <select id="origin_country_province" class="usa-select" formControlName="originProvince" [compareWith]="compareCountryFn">
                <option [ngValue]="null">..Select a Province..</option>
                @for (province of provincesList$ | async; track province) {
                  <option [ngValue]="province">{{
                    province.stateCountryName }}
                  </option>
                }
              </select>
              @if (isFormElementInValid('originCountryId')) {
                <div class="text-danger">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg>Province is required
                </div>
              }
            </div>
          }
          @if ((showOriginDestinationInput || showDestination) && !showDestCanadianProvince) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="destination" class="usa-label">Destination<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <input id="destination" class="usa-input" role="combobox" formControlName="asyncDestinationSearchString" [typeaheadAsync]="true" [typeahead]="dataSourceDestination" (typeaheadLoading)="changeTypeaheadDestinationLoading($event)" (typeaheadOnSelect)="typeaheadDestinationOnSelect($event)"
                typeaheadOptionField="cityName" [typeaheadItemTemplate]="customItemTemplate" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" placeholder="Enter a location or zip code">
              @if (typeaheadLoading) {
                <div class="margin-y-2 spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              }
              @if (this.freightQueryForm.get('destinationId').touched && this.freightQueryForm.get('destinationId').hasError('required')) {
                <div class="text-danger">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Destination is required
                </div>
              }
              @if (freightQueryForm.value.destinationId) {
                <label class="usa-label define-bottom-tag">{{freightQueryForm.value.destinationId?.cityName}} , {{freightQueryForm.value.destinationId?.stateAbbrev}} {{freightQueryForm.value.destinationId?.zipCode}}</label>
              }
            </div>
          }
          @if (showDestCanadianProvince) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="origin_country" class="usa-label">Destination Province<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <select id="destination_country_province" class="usa-select" formControlName="destnProvince" [compareWith]="compareCountryFn">
                <option [ngValue]="null">..Select a Province..</option>
                @for (province of provincesList$ | async; track province) {
                  <option [ngValue]="province">{{
                    province.stateCountryName }}
                  </option>
                }
              </select>
              @if (isFormElementInValid('originCountryId')) {
                <div class="text-danger">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg>Province is required
                </div>
              }
            </div>
          }
        </div>
      }
      <legend class="font-georgia-xl define-margin-top-header">Shipment Information</legend>
      <div class="grid-row grid-gap">
        @if (!showInternational && !isGssr) {
          <div class="grid-col-4">
            <label for="numberOfVehicles" class="usa-label">Mileage<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" class="usa-input" id="miles" formControlName="estimatedMileage" name="mileage" appNumbersOnly>
            @if (this.freightQueryForm.get('estimatedMileage').touched && this.freightQueryForm.get('estimatedMileage').hasError('required')) {
              <div class="text-danger">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Mileage is required
              </div>
            }
            @if (this.freightQueryForm.get('estimatedMileage').touched && this.freightQueryForm.get('estimatedMileage').hasError('pattern')) {
              <div class="text-danger">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Mileage must be numeric
              </div>
            }
          </div>
        }
        @if (isFleetLineVehicle) {
          <div class="grid-col-4">
            <label for="miles" class="usa-label">No. of Vehicles<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" class="usa-input" id="numberOfVehicles" formControlName="numberOfVehicles" name="numberOfVehicles" appNumbersOnly>
            @if (this.freightQueryForm.get('numberOfVehicles').touched && this.freightQueryForm.get('numberOfVehicles').hasError('required')) {
              <div class="text-danger">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> No. of Vehicles is required
              </div>
            }
          </div>
        }
        <div class="grid-col-4">
          <label for="estimatedWeight" class="usa-label">Weight<abbr title="required"
          class="usa-hint usa-hint--required">*</abbr>
          @if (this.isFleetLineVehicle) {
            <abbr title="required"
              class="text-gray-90">
              {{this.weightRanking}}
            </abbr>
          }
        </label>
        <input type="text" class="usa-input" id="estimatedWeight" formControlName="estimatedWeight" (change)="onWeightCubicFtChange()" name="weight" appNumbersOnly maxlength="8">
        @if (this.freightQueryForm.get('estimatedWeight').touched && this.freightQueryForm.get('estimatedWeight').hasError('required')) {
          <div class="text-danger">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Weight is required
          </div>
        }
        @if (this.freightQueryForm.get('estimatedWeight').touched && this.freightQueryForm.get('estimatedWeight').hasError('pattern')) {
          <div class="text-danger">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Weight must be in whole numbers.
          </div>
        }
        @if (this.freightQueryForm.get('estimatedWeight').touched && (this.freightQueryForm.get('estimatedWeight').hasError('max') || this.freightQueryForm.get('estimatedWeight').hasError('min'))) {
          <div class="text-danger">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Weight must fall within range of selected Class.
          </div>
        }
        @if (showGssrError) {
          <div class="text-danger">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Only a Max of 40 lbs per Cu. Ft is allowed
          </div>
        }
      </div>
      @if (!isFleetLineVehicle) {
        <div class="grid-col-4">
          <label for="estimatedCuFt" class="usa-label">Total Shipment Cube (cubic ft)@if (isGssr) {
            <abbr title="required"
            class="usa-hint usa-hint--required">*</abbr>
          }</label>
          <input min="0" type="text" class="usa-input" id="estimatedCuFt" formControlName="estimatedCuFt" (change)="onWeightCubicFtChange()" name="shipment" appNumbersOnly maxlength="8">
          @if (this.freightQueryForm.get('estimatedCuFt').touched && this.freightQueryForm.get('estimatedCuFt').hasError('pattern')) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Total Shipment must be numeric whole numbers
            </div>
          }
          @if (showGssrError) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Only a Max of 40 lbs per Cu. Ft is allowed
            </div>
          }
        </div>
      }
    </div>
    <!-- Service Offerings Multi Select Dropdown
    <div class="grid-row grid-gap">
      <div class="grid-col-5 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="chargebleCodeAdd" class="usa-label text-bold"> Service Offering(s)</label>
        <select id="chargebleCodeAdd" multiple class="define-height-usa-select usa-select maxw-full"
          formControlName="appOfferings" title="Available Service Offerings" name="appChargeCodeList"
          aria-label="Select from available Tsp Service Offerings">
          <option value='null'>-Select TSP(s)-</option>
          <option [ngValue]="mdt" *ngFor="let mdt of offerings">{{mdt.serviceCode}}- {{mdt.serviceDescription}}</option>
        </select>
        <div style="font-weight: 700;">Use "CTRL" to select multiple offerings.</div>
      </div>
      <div class="grid-col-1 mobile-lg:grid-col-12 tablet:grid-col-1 desktop:grid-col-1 text-center pt-3">
        <button type="button" class="usa-button usa-button--hover width-full" (click)="moveItems()">
          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
            <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
          </svg>
        </button>
      </div>
      <div class="grid-col-5 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="assigned_offerings_add" class="usa-label text-bold">Selected Service Offering(s)</label>
        <select multiple id="assigned_offerings_add" formControlName="selectedOfferings"
          class="define-height-usa-select usa-select maxw-full">
          <option
            *ngFor="let selected of selectedOfferings; let i = index"
            [value]="selected.frtTspServiceOfferingsId"
            (dblclick)="handleRateTypesMultiDropdown(i)">
            {{selected.serviceCode}}- {{selected.serviceDescription}}
          </option>
        </select>
        <div style="font-weight: 700;">Double click on the offering to remove.</div>
      </div>
    </div> -->
    @if (showAccessorials) {
      <div class="grid-row" fxLayout="row" fxLayoutAlign="center center">
        <div class="grid-col-6">
          <legend class="font-georgia-xl define-margin-top-header">Accessorials Panel</legend>
        </div>
        <div class="grid-col-3">
          <button type="button" class="usa-button margin-top-3" (click)="addAccessorial()">
            <i class="fa fa-plus" aria-hidden="true"></i> Accessorial
          </button>
        </div>
      </div>
    }
    @if (showAccessorials) {
      @for (objs of freightQueryForm.get('accessorials')['controls']; track objs; let i = $index) {
        <div formArrayName="accessorials">
          <ng-container [formGroupName]="i">
            <div class="grid-row grid-gap">
              <div class="grid-col-3">
                <label class="usa-label">Accessorials<abbr title="required"
                class="usa-hint usa-hint--required">*</abbr></label>
                <select id="accessorial" formControlName="accessorial" class="usa-select" (change)="onAccessorialChange($event, i)" [compareWith]="compareAccessorialFn">
                  <option value='' selected disabled>Choose...</option>
                  @for (accessorial of accessorials; track accessorial) {
                    <option [ngValue]="accessorial">
                      {{ accessorial.accessorialCode }} - {{ accessorial.accessorialDescription }}
                    </option>
                  }
                </select>
              </div>
              @if (this.freightQueryForm.get('accessorials')['controls'][i]['controls'].unitDescription.value !== null) {
                <div class="grid-col-3">
                  <label class="usa-label">{{this.freightQueryForm.get('accessorials')['controls'][i]['controls'].unitDescription.value}}
                    <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                    <input type="text" id="units_1_{{i}}" formControlName="units" name="units" class="usa-input">
                  </div>
                }
                <div class="grid-col-2">
                  <button type="button" class="usa-button usa-button--secondary pin-bottom" (click)="removeAccessorial(i)">Delete
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        }
      }
      <div class="margin-top-4">
        @if (showAccessorials) {
          @if (showAccessorialsError) {
            <div class="text-danger">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Please delete duplicate accessorials to proceed.
            </div>
          }
        }
      </div>
      <div class="grid-row">
        <button type="button" class="usa-button" (click)="saveQuery()" [disabled]="freightQueryForm.invalid || showAccessorialsError || showGssrError">Query</button>
        <button type="button" class="usa-button usa-button--outline" (click)="reset()">Reset</button>
      </div>
    </fieldset>
  </form>
  @if (showQueryGrid) {
    <app-frt-query-results
      [queryResults]="queryResults$"
      [showGrid]="showQueryGrid"
      [userPrefList]="this.userPrefList"
      [screenName]="this.screenName"
      [pickupDate]="this.pickupDatePayLoad"
      [estimatedMileage]="this.estimatedMileage"
      [estimatedWeight] = "this.estWeight"
      [numVehicles] = "this.numVehicles"
    ></app-frt-query-results>
  }
</div>
